import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, RotateCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import AppHeader from '@/components/layout/AppHeader';

interface SideFeilProps {
  tittel: string;
  tekst: string;
  tilbake: { tekst: string; til: string };
  /** Knappen «Prøv igjen» vises bare når denne er satt. */
  onProvIgjen?: () => void;
}

/**
 * Felles feilvisning for en side som ikke får lastet det den skal vise (produksjon, sang).
 * Viser toppmenyen, overskrift, forklaring og vei videre. Tekstene er faste; vis aldri
 * feilmelding, adresse eller svar fra API-et her.
 */
export default function SideFeil({ tittel, tekst, tilbake, onProvIgjen }: SideFeilProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
      <AppHeader />

      <main className="max-w-xl mx-auto p-4 md:p-6">
        <Card className="mt-6 sm:mt-12">
          <CardContent className="flex flex-col items-center gap-4 p-6 text-center sm:p-8">
            <div className="rounded-full bg-muted p-3">
              <AlertCircle className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
            </div>
            <div className="space-y-2">
              <h1 className="text-xl font-semibold sm:text-2xl">{tittel}</h1>
              <p className="text-muted-foreground">{tekst}</p>
            </div>
            <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
              {onProvIgjen && (
                <Button onClick={onProvIgjen} className="w-full sm:w-auto">
                  <RotateCw />
                  Prøv igjen
                </Button>
              )}
              <Button
                asChild
                variant={onProvIgjen ? 'outline' : 'default'}
                className="w-full sm:w-auto"
              >
                <Link to={tilbake.til}>{tilbake.tekst}</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
